import { gql } from '@apollo/client'
import { ORGANIZATION_APPLICATION } from 'requests/fragments/organization'

export const GET_ORGANIZATION_APPLICATION = gql`
  query getOrganization($organizationId: ID!, $contractFilter: ContractFilter) {
    organization(id: $organizationId) {
      ...OrganizationApplication
    }
  }
  ${ORGANIZATION_APPLICATION}
`
